import { defineComponent as _defineComponent } from 'vue'
import { msg_friend_apply_list, msg_handle_friend_apply } from "@/network/socket/SocketReq";
import router from "@/router";
import { usePiniaState } from "@/store/userPinia";
import EventBus from "@/uitls/EventBus";
import { onMounted, onUnmounted, ref } from "vue";
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'NewFriend',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()
const userStore = usePiniaState();
const { toLogin } = userStore;
const newFriendData = ref([])
const zbtype = require(`@/assets/${process.env.VUE_APP_NAME}/zbtype.png`)

onMounted(() => {
    toLogin();
    msg_friend_apply_list()

});
onUnmounted(() => {
    // EventBus.all.clear(); 
    EventBus.off("newFriendRes")
    EventBus.off("newFriend2")
});
const onClickLeft = () => {
    router.back();
}
EventBus.on("newFriend2", (list: Array<any>) => {
    console.log(list);
    newFriendData.value = list;

});
EventBus.on("newFriendRes", () => {
    msg_friend_apply_list()
});
const friendApply = (data, type) => {
    const uid = data.info.uid
    msg_handle_friend_apply(uid, type)
}





const __returned__ = { t, userStore, toLogin, newFriendData, zbtype, onClickLeft, friendApply }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})